import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import btcDepositsSlice from "./reducers/BTCDepositSlice";

const reducers = combineReducers({
   btcDeposits: btcDepositsSlice,
});


const store = configureStore({
   reducer: reducers,
});

export default store;